(function ($) {

	 $(document).ready(function ($) {
	
	 if(window.innerWidth > 768) {
       return;
     }
		 
	 $('div#howitworks + .index-section .grid').slick({
			slidesToShow: 1,
			arrows: false,
			responsive: [
			{
			  breakpoint: 768,
			  settings: {
                arrows: true,
				prevArrow: '.left-arrow',
                nextArrow: '.right-arrow',
				slidesToShow: 1,
				dots: true,
				infinite: true,
				speed: 500,
				fade: true,
				cssEase: 'linear'
			  }
			}
		  ]
		});
	
	});

})(jQuery);
